import React from 'react';
import { Box, Section } from '@common/components';
import { Row, Col, Typography } from 'antd';

const Guide = ({ guide, onClick }) => {
	return (
		<Box className="p-5">
			<Section className="mb-3" hoverable shadowed>
				<Row type="flex" className="login-links">
					<Col flex={1} onClick={() => onClick && onClick(guide)}>
						<Typography.Title level={3}>
							{guide.title}
						</Typography.Title>
						<Typography.Text level={3}>
							{guide.description}
						</Typography.Text>
					</Col>
				</Row>
			</Section>
		</Box>
	);
};

export default Guide;
